'use client';

import UseContainer from './_components';

export default function PointLoungeUsePage() {
  return <UseContainer />;
}
